var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14453 9.71428C1.14453 4.97142 4.9731 1.14285 9.71596 1.14285H38.2874C43.0302 1.14285 46.8588 4.97142 46.8588 9.71428V38.2857C46.8588 43.0286 43.0302 46.8571 38.2874 46.8571H9.71596C4.9731 46.8571 1.14453 43.0286 1.14453 38.2857V9.71428Z",
    fill: "#3F0F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.4729C16 26.628 17.5291 25.1429 19.4286 25.1429C21.328 25.1429 22.8571 26.628 22.8571 28.4729V36.6699C22.8571 38.5147 21.328 40 19.4286 40C17.5291 40 16 38.5147 16 36.6699V28.4729Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4745 32C26.6297 32 25.1445 30.4709 25.1445 28.5714C25.1445 26.672 26.6297 25.1429 28.4745 25.1429H36.6717C38.5165 25.1429 40.0017 26.672 40.0017 28.5714C40.0017 30.4709 38.5165 32 36.6717 32H28.4745Z",
    fill: "#ECB22D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1445 11.33C25.1445 9.48514 26.6737 8 28.5731 8C30.4725 8 32.0017 9.48514 32.0017 11.33V19.5271C32.0017 21.372 30.4725 22.8571 28.5731 22.8571C26.6737 22.8571 25.1445 21.372 25.1445 19.5271V11.33Z",
    fill: "#2FB67C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.33 22.8571C9.48514 22.8571 8 21.328 8 19.4286C8 17.5291 9.48514 16 11.33 16H19.5271C21.372 16 22.8571 17.5291 22.8571 19.4286C22.8571 21.328 21.372 22.8571 19.5271 22.8571H11.33Z",
    fill: "#36C5F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1445 36.5714C25.1445 38.4709 26.6737 40 28.5731 40C30.4725 40 32.0017 38.4709 32.0017 36.5714C32.0017 34.672 30.4725 33.1429 28.5731 33.1429H25.1445V36.5714Z",
    fill: "#ECB22D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5731 22.8571H33.1445V19.4286C33.1445 17.5291 34.6737 16 36.5731 16C38.4725 16 40.0017 17.5291 40.0017 19.4286C40.0017 21.328 38.4725 22.8571 36.5731 22.8571Z",
    fill: "#2FB67C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4286 25.1429H14.8571V28.5714C14.8571 30.4709 13.328 32 11.4286 32C9.52914 32 8 30.4709 8 28.5714C8 26.672 9.52914 25.1429 11.4286 25.1429Z",
    fill: "#E01E5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8571 11.4286V14.8571H19.4286C17.5291 14.8571 16 13.328 16 11.4286C16 9.52914 17.5291 8 19.4286 8C21.328 8 22.8571 9.52914 22.8571 11.4286Z",
    fill: "#36C5F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.dc5ea4efb6b8bc5d6571301f6eb52b72.svg";
export { ForwardRef as ReactComponent };